import { DropdownOptionType } from '@Components/Dropdown/Type';
import { postFedExDetails } from '@Reducers/AdminShipment/actions';
import { AppDispatch } from '@Store';
import * as Yup from 'yup';

export const PaymentTypeOptions: DropdownOptionType[] = [
  { value: 'COD', display: 'COD' },
  { value: 'Cash', display: 'Cash' },
  { value: 'Acc/Prepaid', display: 'Acc/Prepaid' },
];

export const DutyTypeOptions: DropdownOptionType[] = [
  { value: 'DDP', display: 'DDP' },
  { value: 'DDU', display: 'DDU' },
];

export const DeclareCurrencyTypeOptions: DropdownOptionType[] = [
  { value: 'USD', display: 'USD' },
  { value: 'CNY', display: 'CNY' },
  { value: 'HKD', display: 'HKD' },
];
export const ServiceCodeTypeOptions: DropdownOptionType[] = [{ value: 'ADC', display: 'ADC' }];

export const linexInformationValidation = Yup.object().shape({
  type: Yup.string().required('Type is required'),
  accountNo: Yup.mixed()
    .test('is-valid', 'Account is required', (value: any) => {
      if (Array.isArray(value)) return value.length > 0;
      if (typeof value === 'object') return true;
      return !!value;
    })
    .required('Account is required'),
  dutyType: Yup.string()
    .transform(value => (Array.isArray(value) ? '' : value))
    .required('Duty type is required'),
  PaymentType: Yup.string()
    .transform(value => (Array.isArray(value) ? '' : value))
    .required('Payment type is required'),
  // serviceCode: Yup.string()
  //   .transform(value => (Array.isArray(value) ? '' : value))
  //   .required('Service code is required'),
  declareCurrency: Yup.string()
    .transform(value => (Array.isArray(value) ? '' : value))
    .required('Declare currency required'),
  // content: Yup.string().required('Content is required'),
});

export interface linexInformationSchema {
  csp: string;
  type: string;
  accountNo: string;
  dutyType: string;
  PaymentType: string;
  content: string;
}

export const onForward = ({
  values,
  shipmentNumber,
  dispatch,
  nextFunc,
}: {
  values: linexInformationSchema;
  shipmentNumber: string;
  dispatch: AppDispatch;
  nextFunc: () => void;
}) => {
  const body = { ...JSON.parse(JSON.stringify(values)) };
  body.csp = 'linex';
  for (const key in body) {
    if (body[key]) {
      if (key === 'accountNo') {
        body[key] = body[key]?.split('-')?.[0];
      }
    }
  }
  dispatch(
    postFedExDetails({
      shipmentNumber: `${shipmentNumber}`,
      body,
      date: null,
      nextFunc,
    }),
  );
};
